export default "__VITE_ASSET__DuGxfroB__"